module.exports = __webpack_public_path__ + "img/0Q3B7249.a6fe3a6b.webp";